<div class="dropdown" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" data-testid="icon-help-top">
  <div
    class="help-icon-button"
    [ngClass]="{
      home: isHome,
      active: isMenuOpen,
      inactive: !isMenuOpen,
    }"
  >
    <div class="fas fa-question"></div>
  </div>
  @if (isMenuOpen) {
    <div class="dropdown-content">
      <div class="triangle-wrapper"><div class="triangle"></div></div>
      <p class="dropdown-item">
        <a (click)="onRouteSelected(['grid-updates'])" data-testid="link-grid-updates"> GRiD Updates </a>
      </p>
      <p class="dropdown-item">
        <a
          href="https://api.maplecroft.com/v3/document-library/document/quick-start-guide/"
          target="_blank"
          rel="noopener noreferrer"
          data-hook="quick-start-link"
          >Quick Start Guide</a
        >
      </p>
      @for (route of helpMenuRoutes; track route) {
        <p class="dropdown-item">
          <a tabIndex="0" (click)="onRouteSelected(route.link)" [attr.data-testid]="'link-' + route.name | slugify">{{ route.name }}</a>
        </p>
      }
      <p class="dropdown-item" *mcPermission="PermissionSelector.API_DOCS.LINK">
        <a
          href="https://api.maplecroft.com/documentation/"
          target="_blank"
          rel="noopener noreferrer"
          data-hook="help-menu-api-link"
          data-testid="link-country-risk-api"
          >Country Risk API</a
        >
      </p>
      <p class="dropdown-item" *mcPermission="PermissionSelector.API_DOCS_INDUSTRY.LINK">
        <a [href]="industryApiDocLink" target="_blank" rel="noopener noreferrer" data-testid="link-industry-risk-api">Industry Risk API</a>
      </p>
      <p class="dropdown-item">
        <a href="mailto:support@maplecroft.com" target="_top" class="email-support" data-testid="link-email-support">Email Support</a>
      </p>
      <p class="dropdown-item">
        <a [routerLink]="['/privacy-center/cookie-policy']" data-testid="link-cookie-policy">Cookie Policy</a>
      </p>
      <p class="dropdown-item">
        <a
          href="https://www.maplecroft.com/data/global-risk-dashboard/security/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="link-security-compliance"
          >Security & Compliance</a
        >
      </p>
    </div>
  }
</div>
